import { SelectOption } from '@/models/generics'
import { reactive, toRefs } from 'vue'

export interface FileState {
  type: string,
  mapType?: SelectOption | null,
  contentType?: SelectOption | null
  data?: { csvString?: string, header: Array<string>, results: Array<Record<string, any>> }
}

export enum FileStateEventHandlerType {
  File = 'file'
}

export interface FileStateOptions {
  mbLimit?: number
}

export default function useFileState (defaultFileType: string, options?: FileStateOptions) {
  const fileState = reactive<FileState>({
      type: defaultFileType,
      mapType: undefined,
      contentType: undefined,
      data: undefined
  })

  const MbLimit = 10

  const handlers = {
      set (type: FileStateEventHandlerType, key:string, fn:(...args) => any) {
        this[type][key] = fn
      },
      file: {
        parsed (data) {
          // console.log('fileState.handlers.file.parsed', data)
        },
        changed (data) {
          // console.log('fileState.handlers.file.changed', data)
        },
        pre (file: File) {
          if (file.size / 1024 / 1024 < (options?.mbLimit || MbLimit)) return true
          console.warn(`File exceeds size limit of ${options?.mbLimit || MbLimit}mb`)

          return false
        }
      }
    }

  return {
    state: fileState,
    handlers
  }
}
